// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Card.module.scss  */
.Card-module-Root_2DS {
  position: relative;
  overflow: hidden;
  border-radius: 8px; }

.Card-module-Link_2IE {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 8px;
  outline: none;
  box-shadow: none;
  transition: box-shadow 0.2s ease; }
  .Card-module-Link_2IE:hover {
    box-shadow: 0 6px 14px 0 rgba(0, 0, 0, 0.15); }
  .Card-module-Link_2IE:focus-visible {
    outline: 2px solid var(--color-control-border-color-focus);
    outline-offset: -2px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Card/Card.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gCAAgC,EAAE;EAClC;IACE,4CAA4C,EAAE;EAChD;IACE,0DAA0D;IAC1D,oBAAoB,EAAE","sourcesContent":["/*  imported from Card.module.scss  */\n.Card-module-Root_2DS {\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px; }\n\n.Card-module-Link_2IE {\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  border-radius: 8px;\n  outline: none;\n  box-shadow: none;\n  transition: box-shadow 0.2s ease; }\n  .Card-module-Link_2IE:hover {\n    box-shadow: 0 6px 14px 0 rgba(0, 0, 0, 0.15); }\n  .Card-module-Link_2IE:focus-visible {\n    outline: 2px solid var(--color-control-border-color-focus);\n    outline-offset: -2px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
